import { AxiosHeaders, AxiosRequestHeaders } from "axios";
import { retrieveAuthToken } from "./authService";
import { ssoEnabled } from "./ssoEnabled";
import { getCurrentSelectedTenant, getIsSjAdminFromStorage } from "./user";

export const getHeaders = async (noAuth = false) => {
  const authToken = !noAuth ? await retrieveAuthToken() : null;
  const locale = localStorage.getItem("i18nextLng");
  const selectedTenant = getCurrentSelectedTenant();
  const isSjAdmin = getIsSjAdminFromStorage();

  const headers: AxiosRequestHeaders = new AxiosHeaders();
  headers.setAccept("application/json");
  headers.setContentType("application/json");

  headers["ssoEnabled"] = ssoEnabled();

  if (authToken) {
    headers.setAuthorization(`Bearer ${authToken}`);
  }

  if (locale) {
    headers["locale"] = locale;
  }

  if (selectedTenant) {
    headers["SelectedTenant"] = selectedTenant;
  }

  if (isSjAdmin) {
    headers["IsSjAdmin"] = true;
  }

  return headers;
};

export const buildHeaderForUpload = async () => {
  const headers = await getHeaders();
  headers["Content-Type"] = "multipart/form-data";
  return headers;
};
